import { useMutation } from '@apollo/client';
import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Button,
  Heading,
  Text,
  useColorModeValue,
  FormErrorMessage,
  useToast,
} from '@chakra-ui/react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import store from '../store';
import { timeout } from '../utils/helper';
import { AUTH_PLAYER } from '../utils/mutations';
import { greenishColor } from '../utils/theme';

export default function Login() {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [authPlayerWithPassword] = useMutation(AUTH_PLAYER);
  const toast = useToast();

  const handleSubmit = async () => {
    setIsSubmitting(true);
    setError(false);
    try {
      const res = await authPlayerWithPassword({
        variables: { email: email?.toLowerCase(), password },
      });

      if (
        res.data &&
        res.data.authPlayerWithPassword &&
        res.data.authPlayerWithPassword.id
      ) {
        toast({
          title: 'Welcome back, redirecting to your account ✌️',
          status: 'success',
          isClosable: true,
        });
        localStorage.setItem(
          'playerInfo',
          JSON.stringify(res.data.authPlayerWithPassword)
        );
        store.dispatch.userModel.setPlayerInfo(res.data.authPlayerWithPassword);
        await timeout(2000);
        navigate(`/joined-leagues`);
        setIsSubmitting(false);
      } else {
        setError(true);
        setIsSubmitting(false);
      }
    } catch (error) {
      console.log(error);
      setIsSubmitting(false);
    }
  };

  return (
    <Flex
      minH={'100vh'}
      align={'center'}
      justify={'center'}
      bg={useColorModeValue('gray.50', 'gray.800')}
    >
      <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
        <Stack align={'center'}>
          <Heading fontSize={'4xl'}>Sign in to your account</Heading>
          <Text fontSize={'lg'} color={'gray.600'}>
            to enjoy all of our cool{' '}
            <Text as="span" color={greenishColor}>
              features
            </Text>{' '}
            ✌️
          </Text>
        </Stack>
        <Box
          rounded={'lg'}
          bg={useColorModeValue('white', 'gray.700')}
          boxShadow={'lg'}
          p={8}
        >
          <Stack spacing={4}>
            <FormControl id="email" isInvalid={error}>
              <FormLabel>Email address</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError(false);
                }}
              />
            </FormControl>
            <FormControl id="securityCode" isInvalid={error}>
              <FormLabel>Your Password</FormLabel>
              <Input
                value={password}
                type="password"
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError(false);
                }}
              />
              {error ? (
                <FormErrorMessage>Wrong Email or password</FormErrorMessage>
              ) : null}
            </FormControl>

            <Stack spacing={10}>
              <Stack direction={'row'} align={'start'} justify={'flex-end'}>
                <Link to="/forgot-password">
                  <Box color={'blue.400'}>Forgot password?</Box>
                </Link>
              </Stack>
              <Button
                mt="10px"
                bg={greenishColor}
                color={'white'}
                rounded="full"
                _hover={{
                  bg: greenishColor,
                }}
                loadingText={'Submitting...'}
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
                onClick={handleSubmit}
              >
                Sign in
              </Button>
            </Stack>
          </Stack>
        </Box>
        <Text textAlign={'center'}>
          You do not have an account?{' '}
          <Link to="/register">
            <Text as="span" color={'blue.400'}>
              Register now
            </Text>
          </Link>
        </Text>
      </Stack>
    </Flex>
  );
}
